import { state, Cmp } from ":mods";
import { For, batch, createEffect, splitProps } from "solid-js";
import { TableViewProps } from "../model";

function checkTableProps<T extends any[], P extends Record<string, (item: T[0]) => JSX.Element>>(
  props: TableViewProps<T, P>
) {
  if (!props.colsClasses || Object.keys(props.colsClasses)?.length <= 0) {
    console.error("table comopnent: please specify the keys for this table!");
    return false;
  }
  return true;
}

export function Table<T extends any[], P extends Record<string, (item: T[0]) => JSX.Element>>(
  props: TableViewProps<T, P>
) {
  const [local, other] = splitProps(props, [
    "rows",
    "colsClasses",
    "rowClass",
    "rowContainerClass",
    "appendCols",
    "events",
    "noConfirmOnDelete",
  ]);
  // if (!checkTableProps(local)) {
  //   return null;
  // }
  // local.rows = local.rows ?? []
  const cols_keys = Object.keys(local.colsClasses);
  const row_container_class = "space-x-2 items-center" + local.rowContainerClass ?? "";
  const row_class = "items-center " + local.rowClass ?? "";
  const $selected_items = state.create([] as number[]);
  const on_single_row = local.events?.onSingleRow ?? function () {};
  const on_all_rows = local.events?.onAllRows ?? function () {};
  // const on_delete = local.events?.onDelete
  // console.log("inside table setup");
  // createEffect(() => {
  //   console.log("selected items :: ", $selected_items.value);
  // });

  // createEffect(() => {
  //   console.log("table effect :: ", local.rows);
  // });

  function onAllSelected(checked: boolean) {
    $selected_items.set(checked ? local.rows.map((_, i) => i) : []);
    on_all_rows({
      event: checked ? "selected" : "unselected",
      selected: $selected_items.value,
      rows: local.rows,
    });
  }
  function onSingleSelected(index: number, currentlyChecked: boolean) {
    const item = local.rows[index];
    // console.log("on single seleceted :: ", currentlyChecked, item);
    // uncheck
    if (currentlyChecked) {
      $selected_items.set((s) => s.filter((i) => i !== index));
    } else {
      $selected_items.set((s) => [...s, index]);
    }
    on_single_row({
      event: currentlyChecked ? "unselected" : "selected",
      item: local.rows[index],
      index,
      rows: local.rows,
    });
  }
  function onAlldelete() {
    const selected = $selected_items.value.length > 0 ? $selected_items.value : local.rows.map((_, i) => i);

    batch(() => {
      const before_length = local.rows.length;
      on_all_rows({ event: "delete", selected, rows: local.rows });
      if (local.rows.length !== before_length) {
        console.log("before and after lengths :: ", before_length, local.rows.length);
        if (local.rows.length <= 0) {
          $selected_items.set([]);
        } else {
          $selected_items.set((s) => s.filter((i) => selected.indexOf(i) < 0));
        }
      }
    });
  }
  async function onSingleDelete(index: number) {
    const item = local.rows[index];
    // let indieces = [index]
    // if (on_delete) {
    //   indieces = await Promise.resolve(on_delete({selected: [index], rows: local.rows})).then(ids => ids)
    // }
    batch(() => {
      on_single_row({ event: "delete", item, index, rows: local.rows });
      // if rows have been updated
      if (local.rows.indexOf(item) < 0) {
        // if item was in the selected list
        if ($selected_items.value.indexOf(index) >= 0) {
          // onSingleSelected(index, true)
          $selected_items.set((s) => {
            const new_sequence = [] as number[];
            s.forEach((i) => {
              if (i !== index) {
                new_sequence.push(i - 1);
              }
            });
            return new_sequence;
          });
        }
      }
    });
  }

  function onAllCreate() {
    on_all_rows({ event: "create", selected: $selected_items.value, rows: local.rows });
  }
  function onSingleCreate(index: number) {
    on_single_row({ event: "create", item: local.rows[index], index, rows: local.rows });
  }
  function onSingleClicked(e: Event, index: number) {
    on_single_row({ event: "clicked", item: local.rows[index], index, rows: local.rows });
  }
  function onAllEdit() {
    on_all_rows({ event: "edit", selected: $selected_items.value, rows: local.rows });
  }
  function onSingleEdit(index: number) {
    on_single_row({ event: "edit", item: local.rows[index], index, rows: local.rows });
  }

  return (
    <main {...other}>
      <header
        class={`sticky top-0 !z-100 flex flex-row justify-between bg#p text#pt py-0.5 rounde-lg ${row_container_class}`}
      >
        <div class="flex flex-row !w-10% space-x-2 justify-evenly items-center children:(cursor-pointer)">
          <input
            type="checkbox"
            class="flex flex-row bg#pt w-24px h-24px"
            onchange={(e) => onAllSelected(e.currentTarget.checked)}
          />
          <i
            class="icon-ic:baseline-delete w-26px h-26px"
            onclick={() => {
              if (local.noConfirmOnDelete) {
                onAlldelete();
              } else {
                Cmp.Popup.actions.pushConfirmDialog({
                  title: "Are You Sure?",
                  message: "Are you sure you want to delete all selected items?",
                  events: {
                    onConfirmed() {
                      onAlldelete();
                    },
                  },
                });
              }
            }}
          />
          <i class="icon-zondicons:add-solid w-24px h-24px" onclick={onAllCreate} />
          <i class="icon-mingcute:edit-fill w-20px h-20px" onclick={onAllEdit} />
        </div>
        <div class={row_class}>
          <For each={cols_keys}>
            {(k) => {
              return <span class={`${local.colsClasses[k]}`}>{k}</span>;
            }}
          </For>
        </div>
      </header>
      {/* rows */}
      <section class="flex flex-col w-full mt-2 space-y-2">
        <For each={local.rows}>
          {(item, index) => {
            const $is_selected = state.createMemo(() => $selected_items.value.indexOf(index()) >= 0);
            return (
              <div class={row_container_class}>
                <div class="flex flex-row !w-10% w-fit space-x-2 justify-evenly items-center children:(cursor-pointer)">
                  <input
                    type="checkbox"
                    class="flex flex-row bg#pt w-20px h-20px"
                    checked={$is_selected()}
                    onChange={() => onSingleSelected(index(), $is_selected())}
                  />
                  <i
                    class="icon-ic:baseline-delete w-24px h-24px text-red"
                    onclick={() => {
                      if (local.noConfirmOnDelete) {
                        onSingleDelete(index());
                      } else {
                        Cmp.Popup.actions.pushConfirmDialog({
                          title: "Are You Sure?",
                          message: "Are you sure you want to delete item?",
                          events: {
                            onConfirmed() {
                              onSingleDelete(index());
                            },
                          },
                        });
                      }
                    }}
                  />
                  <i class="icon-zondicons:add-solid w-20px h-20px" onclick={() => onSingleCreate(index())} />
                  <i class="icon-mingcute:edit-fill w-20px h-20px" onclick={() => onSingleEdit(index())} />
                </div>
                <button
                  class={`mx-0 px-0 cursor-pointer ${row_class}`}
                  onclick={(e: Event) => onSingleClicked(e, index())}
                >
                  <For each={cols_keys}>
                    {(k) => {
                      if (local.appendCols && local.appendCols[k]) {
                        const v = local.appendCols[k];
                        return <div class={`${local.colsClasses[k]}`}>{v(item)}</div>;
                      }
                      const v = item[k] ?? "Not Set";

                      return <span class={`${local.colsClasses[k]}`}>{v}</span>;
                    }}
                  </For>
                </button>
              </div>
            );
          }}
        </For>
      </section>
    </main>
  );
}
